module.exports = __webpack_public_path__ + "img/guywdrill.3447b69b.png";